const residentialRate = () => {
  return {
    name: 'Virginia Schedule 1',
    title: 'Residential Service',
    rateElements: [
      // Fixed Monthly Charge
      {
        rateElementType: 'FixedPerMonth',
        name: 'Basic Customer Charge',
        rateComponents: [
          {
            charge: 7.58,
            name: 'Basic Customer Charge',
          },
        ],
      },
      // Energy Charges for Distribution kWh
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Distribution kWh Charge - Summer',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.024986, // 2.4986¢ per kWh
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            months: [5, 6, 7, 8], // June - September
            name: 'First 800 kWh Charge - Summer',
          },
          {
            charge: 0.017955, // 1.7955¢ per kWh
            min: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [5, 6, 7, 8], // June - September
            name: 'Over 800 kWh Charge - Summer',
          },
        ],
      },
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Distribution kWh Charge - Winter',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.024986, // 2.4986¢ per kWh
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            months: [0, 1, 2, 3, 4, 9, 10, 11], // Jan-May, Oct-Dec
            name: 'First 800 kWh Charge - Winter',
          },
          {
            charge: 0.017955, // 1.7955¢ per kWh
            min: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [0, 1, 2, 3, 4, 9, 10, 11], // Jan-May, Oct-Dec
            name: 'Over 800 kWh Charge - Winter',
          },
        ],
      },
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Generation kWh Charge - Summer',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.029421, // 2.9421¢ per kWh
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            months: [5, 6, 7, 8], // June - September
            name: 'First 800 Generation kWh Charge - Summer',
          },
          {
            charge: 0.044768, // 4.4768¢ per kWh
            min: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [5, 6, 7, 8], // June - September
            name: 'Over 800 kWh Charge - Summer',
          },
        ],
      },
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Generation kWh Charge - Winter',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.029421, // 2.9421¢ per kWh
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            months: [0, 1, 2, 3, 4, 9, 10, 11], // Jan-May, Oct-Dec
            name: 'First 800 Generation kWh Charge - Winter',
          },
          {
            charge: 0.022706, // 2.2706¢ per kWh
            min: [800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800, 800],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [0, 1, 2, 3, 4, 9, 10, 11], // Jan-May, Oct-Dec
            name: 'Over 800 Generation kWh Charge - Winter',
          },
        ],
      },
      // Transmission Charge
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Transmission Charge',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.0097, // .970¢ per kWh
            months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // All
            name: 'Transmission kWh Charge',
          },
        ],
      },
    ],
  };
};

export default residentialRate;
